import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './components/Home';
import About from './components/About';
import Contact from './components/Contact';
import Experience from './components/Experience';
import ProjectDetail from './components/ProjectDetail';
import GameModal from './components/GameModal'; // Add this import
import 'devicon/devicon.min.css'; // Add Devicon CSS
import './App.css';

function App() {
    return (
        <Router>
            <div className="App">
                <GameModal /> {/* Add this component */}
                <Header />
                <main>
                    <Routes>
                        <Route path="/" element={<Home />} />
                        <Route path="/about" element={<About />} />
                        <Route path="/contact" element={<Contact />} />
                        <Route path="/experience" element={<Experience />} />
                        <Route path="/projects/:projectId" element={<ProjectDetail />} />
                    </Routes>
                </main>
                <Footer />
            </div>
        </Router>
    );
}

export default App;